'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('./events/index.js');
var index$2 = require('./methods/index.js');
var session = require('./session/session.js');
var transport = require('./transport/transport.js');
var inMemoryApiCache_service = require('./cache/in-memory-api-cache.service.js');

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class Magic {
  constructor(cacheService) {
    this.events = index.events;
    this.methods = index$2;
    this.session = session.session;
    this.cacheService = cacheService;
  }
  setup(opts) {
    return transport.transport.setup(opts);
  }
  destroy() {
    return transport.transport.destroy();
  }
  getLastRequestTimestamp() {
    return transport.transport.getLastTimestamp();
  }
  invokeCached(ttl, methodClass, method) {
    return (...args) => __async(this, null, function* () {
      const cacheKey = this.generateCacheKey(methodClass.constructor.name, method, args);
      const cachedResponse = this.cacheService.get(cacheKey);
      if (cachedResponse !== null) {
        return cachedResponse;
      }
      const response = methodClass[method].call(methodClass, ...args);
      this.cacheService.set(cacheKey, response, ttl);
      return response;
    });
  }
  deleteCached(methodClass, method) {
    return (...args) => __async(this, null, function* () {
      const cacheKey = this.generateCacheKey(methodClass.constructor.name, method, args);
      const cachedResponse = this.cacheService.get(cacheKey);
      if (cachedResponse !== null) {
        this.cacheService.deleteCached(cacheKey);
      }
    });
  }
  generateCacheKey(className, methodName, params) {
    const keyObject = {
      className,
      methodName,
      params
    };
    return JSON.stringify(keyObject);
  }
}
const magic = new Magic(inMemoryApiCache_service.InMemoryApiCacheService.getInstance());

exports.magic = magic;
